function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16 8.5C16 12.918 12.418 16.5 8 16.5C3.582 16.5 0 12.918 0 8.5C0 4.082 3.582 0.5 8 0.5C12.418 0.5 16 4.082 16 8.5ZM8.28667 6.406C7.50867 6.72933 5.95333 7.39933 3.62133 8.41533C3.24267 8.566 3.044 8.71333 3.026 8.85733C2.99533 9.10133 3.30067 9.19733 3.71533 9.32733C3.772 9.34533 3.83067 9.36333 3.89067 9.38333C4.29933 9.516 4.84867 9.67133 5.134 9.67733C5.39333 9.68267 5.68267 9.576 6.002 9.35733C8.18067 7.886 9.30533 7.14267 9.376 7.12667C9.426 7.11533 9.49533 7.10067 9.542 7.14267C9.58867 7.184 9.584 7.26267 9.57933 7.284C9.54867 7.41267 8.35267 8.52533 7.73267 9.10133C7.53933 9.28067 7.40267 9.408 7.37467 9.43733C7.312 9.502 7.248 9.564 7.18667 9.62333C6.80667 9.98867 6.52267 10.2633 7.20267 10.7113C7.52933 10.9267 7.79067 11.1047 8.05133 11.282C8.336 11.476 8.62 11.6693 8.988 11.9107C9.08133 11.972 9.17067 12.0353 9.258 12.0973C9.58933 12.334 9.88733 12.546 10.2553 12.5127C10.4687 12.4927 10.69 12.292 10.802 11.6927C11.0667 10.2753 11.588 7.206 11.7087 5.94067C11.716 5.83561 11.7115 5.73006 11.6953 5.626C11.6856 5.54195 11.6447 5.46462 11.5807 5.40933C11.4853 5.33133 11.3373 5.31467 11.2707 5.316C10.97 5.32133 10.5087 5.482 8.28667 6.406V6.406Z",
  fill: "#1F2145"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0 0.5)"
})));

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c26c9c8c.svg";
export { ForwardRef as ReactComponent };